<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <form
                                    class="flex flex-wrap -m-4"
                                    @submit.prevent="saveJenisPengadaan"
                                >
                                    <div class="p-4 lg:w-1/2 md:w-full">
                                        <div class="flex border rounded-lg border-gray-200 p-4 flex-col">
                                            <JetLabel
                                                class="w-full"
                                                for="nama_jenis_pengadaan"
                                                value="Nama Jenis Pengadaan"
                                            />
                                            <Input
                                                id="nama_jenis_pengadaan"
                                                v-model="form.nama_jenis_pengadaan"
                                                type="text"
                                                placeholder=""
                                                class="mt-1 block w-full"
                                                :class="{
                                                    'p-invalid': form.errors.nama_jenis_pengadaan,
                                                }"
                                            />
                                            <InputError
                                                :message="form.errors.nama_jenis_pengadaan"
                                                class="mt-2"
                                            />
                                            <JetLabel
                                                class="w-full mt-3"
                                                for="keterangan"
                                                value="Keterangan"
                                            />
                                            <Textarea
                                                id="keterangan"
                                                v-model="form.keterangan"
                                                class="mt-1 block w-full"
                                                :class="{
                                                    'p-invalid': form.errors.keterangan,
                                                }"
                                                autoResize
                                                rows="5"
                                                cols="30" />
                                            <InputError
                                                :message="form.errors.keterangan"
                                                class="mt-2"
                                            />
                                        </div>
                                    </div>
                                    <div class="p-4 lg:w-1/2 md:w-full">
                                    </div>
                                    <div class="p-4 pt-1 lg:w-full md:w-full">
                                        <div class="flex flex-wrap border rounded-lg border-gray-200 p-4">
                                            <div class="mb-3 w-6/12">

                                            </div>
                                            <div class="mb-3 w-6/12">
                                                <JetLabel
                                                    class="w-full text-right"
                                                    for="nama_tahapan_insert"
                                                    value='Nama Tahapan<br><span class="text-red-500">* Tekan enter untuk menambah tahapan pengadaan</span>'
                                                />
                                                <Input
                                                    id="nama_tahapan_insert"
                                                    v-model="nama_tahapan_insert"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1  block"
                                                    @keyup.enter="addNamaTahapanPengadaan"
                                                />
                                            </div>
                                            <OrderList v-model="tahapan_pengadaan_list" listStyle="height:auto" dataKey="id" class="w-full">
                                                <template #header>Tahapan Pengadaan</template>
                                                <template #item="slotProps">
                                                    <div class="flex flex-wrap align-items-center gap-3">
                                                        <div class="flex-1 flex flex-column gap-2">
                                                            <span @click="removeTahapanPengadaan(slotProps)" class="text-red-300 w-6"><i class="pi pi-times"></i></span>
                                                            <span class="w-6">{{ slotProps.index + 1 }}.</span>
                                                            <span class="">{{ slotProps.item.nama_tahapan }}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                            </OrderList>
                                            <InputError
                                                :message="form.errors.tahapan_pengadaan_list"
                                                class="mt-2"
                                            />
                                        </div>
                                    </div>
                                    <div class="lg:w-full md:w-full">
                                        <div class="flex flex-col mb-6">
                                            <div class="w-full px-3 text-center">
                                                <ButtonSave @click="saveJenisPengadaan" label="Simpan Data" />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import JetLabel from "@/Jetstream/Label";
import Select from "@/Components/Select";
import Input from "@/Components/Input.vue";
import InputError from "@/Components/InputError.vue";
import MultiSelect from "primevue/multiselect";
import Dialog from "primevue/dialog";
import Textarea from "primevue/textarea";
import Checkbox from "primevue/checkbox";
import OrderList from 'primevue/orderlist';
import InertiaButtonSave from "@/Components/InertiaButtonSave.vue";
import InertiaButtonEdit from "@/Components/InertiaButtonEdit.vue";
import ButtonSave from "@/Components/ButtonSave.vue";
import Tag from "primevue/tag";
import { Pesan } from "@/constants";

export default defineComponent({
    components: {
        AppLayout,
        BreadCrumb,
        JetLabel,
        Select,
        Input,
        InputError,
        MultiSelect,
        Dialog,
        Textarea,
        Checkbox,
        OrderList,
        InertiaButtonSave,
        InertiaButtonEdit,
        ButtonSave,
        Tag,
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: "POST",
                id: null,
                nama_jenis_pengadaan: null,
                keterangan: null,
                tahapan_pengadaan_list: null,
            }),
            tahapan_pengadaan_list: null,
            nama_tahapan_insert: null,
        };
    },
    created(){
        if (this.$page.props.is_edit) {
            this.form.id = this.$page.props.jenis_pengadaan.id;
            this.form.nama_jenis_pengadaan = this.$page.props.jenis_pengadaan.nama_jenis_pengadaan;
            this.form.keterangan = this.$page.props.jenis_pengadaan.keterangan;

            let temp_tahapan_pengadaan_list = [];
            _.forEach(this.$page.props.tahapan_pengadaan, function(item){
                temp_tahapan_pengadaan_list.push({
                    id: item.urutan_ke,
                    nama_tahapan: item.nama_tahapan,
                });
            });

            this.form.tahapan_pengadaan_list = temp_tahapan_pengadaan_list;
            this.tahapan_pengadaan_list = temp_tahapan_pengadaan_list;
        }
    },
    methods: {
        resetForm: function (event) {
            this.form.id = null;
            this.form.nama_jenis_pengadaan = null;
            this.form.keterangan = null;
            this.form.tahapan_pengadaan_list = null;
            this.tahapan_pengadaan_list = null;
            this.nama_tahapan_insert = null;
            this.form.clearErrors();
        },
        saveJenisPengadaan: function (event) {
            if (event.type === 'submit') {
                return;
            }
            let self = this;
            self.reorderTahapanPengadaanList();
            self.form.tahapan_pengadaan_list = self.tahapan_pengadaan_list;
            this.form.post(route("jenispengadaan.store"), {
                errorBag: "saveJenisPengadaan",
                preserveScroll: true,
                onSuccess: () => {
                    self.resetForm();
                },
                onFinish: () => {
                    //
                },
            });
        },
        addNamaTahapanPengadaan: function (event) {
            if (this.nama_tahapan_insert) {
                if (!this.tahapan_pengadaan_list) {
                    this.tahapan_pengadaan_list = [];
                }
                this.tahapan_pengadaan_list.push({
                    id: this.tahapan_pengadaan_list.length + 1,
                    nama_tahapan: this.nama_tahapan_insert,
                });
                this.nama_tahapan_insert = null;
            }
        },
        removeTahapanPengadaan: function (slotProps) {
            this.tahapan_pengadaan_list.splice(slotProps.index, 1);
            this.$emit('reorder');
            this.reorderTahapanPengadaanList();
        },
        reorderTahapanPengadaanList: function () {
            let temp_tahapan_pengadaan_list = [];
            _.forEach(this.tahapan_pengadaan_list, function(item, index){
                temp_tahapan_pengadaan_list.push({
                    id: index + 1,
                    nama_tahapan: item.nama_tahapan,
                });
            });
            this.tahapan_pengadaan_list = temp_tahapan_pengadaan_list;
        },
    },
});
</script>
